import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-image-picker',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss'],
  standalone: false,
})
export class ImagePickerComponent {
  @Input() public text: string = 'Ajouter une photo';

  @Input() public imageSource: string | undefined;

  public textDelete: string = 'Supprimer la photo';

  @Output() public onFileChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() public onDeleteFile: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  imageSourceNotExists(): boolean {
    return this.imageSource === undefined || this.imageSource === null || this.imageSource === '';
  }

  onFileChangeHandler(event: any): void {
    this.onFileChange.emit(event);
  }

  onClickDeleteProfilePicture() {
    this.onDeleteFile.emit();
  }
}
